module.exports = __webpack_public_path__ + "static/media/YF66_0.daa2db4f.jpg";